import React from 'react';
import { PageLead } from './partials/PageLead';
import { PageTypeDescription, PageTypeIcon } from '../PageType';
import { PageLeadHeadline } from './partials/PageLeadHeadline';
import { PageLeadSkipLinks } from './partials/PageLeadSkipLinks';
import { PageType } from '../../../types/api/PageType';
import { PageLeadMetaInfo } from './partials/PageLeadMetaInfo';
import { PageLeadModifier } from './partials/PageLead';
import { PageTypeIconModifiers } from '../PageType/PageTypeIcon';

type PageHeaderPageType = {
  pageType: PageType;
  title: string;
};

/**
 * Page Lead with Icon and Description of a Page Type.
 */
export function PageLeadPageType({ pageType, title }: PageHeaderPageType) {
  return (
    <>
      <PageLead modifier={PageLeadModifier.INLINE_ICON}>
        <div className="page-lead__page-type-container">
          <PageTypeIcon pageType={pageType} modifier={PageTypeIconModifiers.X_LARGE_ROUND} />
          <div className="page-lead__page-type-text-container">
            <PageLeadHeadline>
              {title}
              <PageLeadMetaInfo />
            </PageLeadHeadline>
            <p>
              <PageTypeDescription pageType={pageType} />
            </p>
          </div>
        </div>
      </PageLead>
      <PageLeadSkipLinks />
    </>
  );
}
